import { useAccessibility } from 'context/hooks/useAccessibility'
import Loading from '../UI/Loading'

import './styles.scss'

function LoadingAuth() {
  const { contrastIsSelected } = useAccessibility()

  return (
    <article
      className={`auth-spin ${contrastIsSelected ? 'contrastMode' : ''}`}
    >
      <Loading title="Autenticando..." size="bigger" />
    </article>
  )
}

export default LoadingAuth
